module.exports = "<div ng-show=\"$ctrl.canChange\" class=\"resize-handle\"><div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/dashboard/resize-handler/resize-handler.component.html
// module id = 1003
// module chunks = 0